import React from "react";
import {
  List,
  Datagrid,
  FunctionField,
  Filter,
  TextInput,
  useListContext,
  TopToolbar,
  CreateButton,
  ExportButton,
  sanitizeListRestProps,
  BooleanField,
} from "react-admin";
import useUser from "../../hooks/useUser";
import LinkTextField from "../../components/LinkTextField";
import CopyButton from "../../components/CopyButton";
import ListPagination from "../../components/ListPagination";
import { perPage } from "../../defaults/Defaults";
import ColoredBooleanField from "../../components/ColoredBooleanField";

const ListActions = (props) => {
  const { className, exporter, filters, maxResults, ...rest } = props;
  const { currentSort, resource, filterValues, basePath, total } =
    useListContext();
  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {props.user.role === "super-admin" && (
        <CreateButton basePath={basePath} />
      )}
      <ExportButton
        disabled={total === 0}
        resource={resource}
        sort={currentSort}
        filterValues={filterValues}
        maxResults={maxResults}
      />
    </TopToolbar>
  );
};

const OrganizationFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search by name" source="name" alwaysOn />
  </Filter>
);

const OrganizationList = (props) => {
  const user = useUser();
  return (
    <List
      {...props}
      title="Organizations"
      perPage={perPage}
      pagination={<ListPagination />}
      filters={<OrganizationFilter />}
      actions={<ListActions user={user} />}
      bulkActionButtons={false}
    >
      <Datagrid>
        <LinkTextField
          source="name"
          basePath="Organizations"
          destinationPath="show"
          target="_self"
        ></LinkTextField>
        <CopyButton
          source="id"
          label="Email"
          message="Copied Organization Email to clipboard."
        >
          <FunctionField
            label="Email"
            render={(record) =>
              `${window.location.origin.includes("https://app") ? "" : "test"}${
                record.id
              }@alerts.sos-tech.com`
            }
          />
        </CopyButton>
        {user && user.role === "super-admin" && (
          <ColoredBooleanField
            source="is_channel_partner"
            label="Channel P."
            falseColor="transparent"
            trueColor="black"
          />
        )}
        {user && user.role === "super-admin" && (
          <ColoredBooleanField
            source="is_law_enforcement"
            label="L.E."
            falseColor="transparent"
            trueColor="blue"
          />
        )}
        <ColoredBooleanField source="zone_status" label="Zones" />
        <ColoredBooleanField source="notification_status" label="Alerts" />
        <ColoredBooleanField source="active" label="Active" />
      </Datagrid>
    </List>
  );
};
export default OrganizationList;
